const initialState = {
  rbacContext: null,
  teamMembers: null,
  dashboard: null,
  scopedProjects: null,
};

const builderTeamReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_BUILDER_RBAC_CONTEXT":
      return { ...state, rbacContext: action.data };
    case "GET_BUILDER_TEAM_MEMBERS":
      return { ...state, teamMembers: action.data };
    case "GET_BUILDER_DASHBOARD":
      return { ...state, dashboard: action.data };
    case "GET_BUILDER_SCOPED_PROJECTS":
      return { ...state, scopedProjects: action.data };
    case "ADD_BUILDER_TEAM_MEMBER":
      return { ...state };
    case "DELETE_BUILDER_TEAM_MEMBER":
      return { ...state };
    default:
      return state;
  }
};

export default builderTeamReducer;
